import * as React from 'react';
import classnames from 'classnames';
import styles from './FieldDescriptionBlock.styl';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
const col12 = 12;
const FieldDescriptionBlock = ({ iconName, title, style, texts }) => (React.createElement("div", { className: `${styles.row} ${style == 'imprintDesc' ? styles.imprintDesc : styles.termDesc}` },
    React.createElement("div", { className: classnames(styles.blockHeader, { [styles.onlyIcon]: !title }) },
        iconName && React.createElement("div", { className: styles.round },
            React.createElement(IconSVG, { className: styles.icon, name: iconName, customDimensions: true })),
        title && React.createElement("div", { className: styles.textTitle },
            React.createElement("b", null, title))),
    React.createElement("div", { className: styles.text }, texts.map((text, index, array) => (React.createElement(React.Fragment, { key: index },
        text,
        array.length - index > 1 && React.createElement(React.Fragment, null,
            React.createElement("br", null),
            React.createElement("br", null))))))));
export default FieldDescriptionBlock;
